<template>
    <div class="AboutDetail">
        <!-- 头部导航公共组件 -->
        <Header :iseNavigat="isChildeNavigat" :isScroll="isScroll"></Header>

        <div class="about-detail-main">
            <el-row :gutter="10">
                <el-col :lg="{span:'4-8'}" :md="8" :sm="12" :xs="24" v-for="(item, index) in imagesList" :key="index" >
                    <div style="padding-bottom: 15px;height: 23vh;cursor: pointer;" :key="index" @click="handleImagePreview(index)">
                        <img :src="item" style=" width: 100%;height: 100%;object-fit: contain;">
                    </div>
                </el-col>
            </el-row>
        </div>

        <!-- 图片预览弹窗 -->
        <div class="Image-Preview-box" v-if="ImagePreviewModle">
            <div style="position: fixed;z-index: 999;right: 20px;top: 20px;cursor: pointer;" @click="handelImagePreviewClose">
                <img src="../assets/images/close-white.png" />
            </div>
            <el-carousel :interval="0" arrow="always" :autoplay="false" :loop="false" class="Image-Preview-box" ref="carousel" :initial-index="activeIndexInitial" v-model="activeIndex" @change="handleArrowClick">
                <el-carousel-item v-for="(item, index) in imagesList" :key="index">
                    <section class="Image-Preview-box" @click="handelImagesExitFullscreen">
                        <img :src="item"/>
                    </section>
                </el-carousel-item>
            </el-carousel>
        </div>

    </div>
</template>

<script>
import Header from '@/components/Header.vue'
export default {
    name: 'AboutDetail',
    components: {
        Header,
        // Footer,
        // HelloWorld,
        // loading
    },
    data () {
        return {
            isScroll: 4,
            videoHeight: 0,
            isChildeNavigat: true,
            ImagePreviewModle: false,
            // images: [
            //     require('@/assets/images/about/about1.jpeg'),
            //     require('@/assets/images/about/about2.jpeg'),
            //     require('@/assets/images/about/about3.jpeg'),
            //     require('@/assets/images/about/about4.jpeg'),
            //     require('@/assets/images/about/about5.jpeg'),
            //     require('@/assets/images/about/about6.jpeg'),
            //     require('@/assets/images/about/about7.jpeg'),
            //     require('@/assets/images/about/about8.jpeg'),
            //     require('@/assets/images/about/about9.jpeg'),
            //     require('@/assets/images/about/about10.jpeg'),
            //     require('@/assets/images/about/about11.jpeg'),
            //     require('@/assets/images/about/about12.jpeg'),
            //     require('@/assets/images/about/about13.jpeg'),
            //     require('@/assets/images/about/about14.jpeg'),
            //     require('@/assets/images/about/about15.jpeg'),
            //     require('@/assets/images/about/about16.jpeg'),
            //     require('@/assets/images/about/about17.jpeg'),
            //     require('@/assets/images/about/about18.jpeg'),
            //     require('@/assets/images/about/about19.jpeg'),
            //     require('@/assets/images/about/about20.jpeg'),
            //     require('@/assets/images/about/about21.jpeg'),
            //     require('@/assets/images/about/about22.jpeg'),
            //     require('@/assets/images/about/about23.jpeg'),
            //     require('@/assets/images/about/about24.jpeg'),
            //     require('@/assets/images/about/about25.jpeg'),
            //     require('@/assets/images/about/about26.jpeg'),
            //     // 更多图片路径
            // ],
            // fullImgas: [
            //     require('@/assets/images/about/full/about_1.jpeg'),
            //     require('@/assets/images/about/full/about_2.jpeg'),
            //     require('@/assets/images/about/full/about_3.jpeg'),
            //     require('@/assets/images/about/full/about_4.jpeg'),
            //     require('@/assets/images/about/full/about_5.jpeg'),
            //     require('@/assets/images/about/full/about_6.jpeg'),
            //     require('@/assets/images/about/full/about_7.jpeg'),
            //     require('@/assets/images/about/full/about_8.jpeg'),
            //     require('@/assets/images/about/full/about_9.jpeg'),
            //     require('@/assets/images/about/full/about_10.jpeg'),
            //     require('@/assets/images/about/full/about_11.jpeg'),
            //     require('@/assets/images/about/full/about_12.jpeg'),
            //     require('@/assets/images/about/full/about_13.jpeg'),
            //     require('@/assets/images/about/full/about_14.jpeg'),
            //     require('@/assets/images/about/full/about_15.jpeg'),
            //     require('@/assets/images/about/full/about_16.jpeg'),
            //     require('@/assets/images/about/full/about_17.jpeg'),
            //     require('@/assets/images/about/full/about_18.jpeg'),
            //     require('@/assets/images/about/full/about_19.jpeg'),
            //     require('@/assets/images/about/full/about_20.jpeg'),
            //     require('@/assets/images/about/full/about_21.jpeg'),
            //     require('@/assets/images/about/full/about_22.jpeg'),
            //     require('@/assets/images/about/full/about_23.jpeg'),
            //     require('@/assets/images/about/full/about_24.jpeg'),
            //     require('@/assets/images/about/full/about_25.jpeg'),
            //     require('@/assets/images/about/full/about_26.jpeg'),
            //     require('@/assets/images/about/full/about_27.jpeg'),
            //     require('@/assets/images/about/full/about_28.jpeg'),
            //     require('@/assets/images/about/full/about_29.jpeg'),
            //     require('@/assets/images/about/full/about_30.jpeg'),
            //     require('@/assets/images/about/full/about_31.jpeg'),
            //      require('@/assets/images/about/full/about_32.jpeg'),
            //     require('@/assets/images/about/full/about_33.jpeg'),
            //     require('@/assets/images/about/full/about_34.jpeg'),
            //     require('@/assets/images/about/full/about_35.jpeg'),
            //     require('@/assets/images/about/full/about_36.jpeg'),
            //     require('@/assets/images/about/full/about_37.jpeg'),
            //     require('@/assets/images/about/full/about_38.jpeg'),
            //     require('@/assets/images/about/full/about_39.jpeg'),
            //     require('@/assets/images/about/full/about_40.jpeg'),
            //     require('@/assets/images/about/full/about_41.jpeg'),
            //     require('@/assets/images/about/full/about_42.jpeg'),
            //     require('@/assets/images/about/full/about_43.jpeg'),
            //     require('@/assets/images/about/full/about_44.jpeg'),
            //     require('@/assets/images/about/full/about_45.jpeg'),
            //     require('@/assets/images/about/full/about_46.jpeg'),
            //     require('@/assets/images/about/full/about_47.jpeg'),
            //     require('@/assets/images/about/full/about_48.jpeg'),
            //     require('@/assets/images/about/full/about_49.jpeg'),
            //     require('@/assets/images/about/full/about_50.jpeg'),
            //     require('@/assets/images/about/full/about_51.jpeg'),
            //     require('@/assets/images/about/full/about_52.jpeg'),
            //     require('@/assets/images/about/full/about_53.jpeg'),
            //     require('@/assets/images/about/full/about_54.jpeg'),
            //     require('@/assets/images/about/full/about_55.jpeg'),
            //     require('@/assets/images/about/full/about_56.jpeg'),
            //     require('@/assets/images/about/full/about_57.jpeg'),
            //     require('@/assets/images/about/full/about_58.jpeg'),
            //     require('@/assets/images/about/full/about_59.jpeg'),
            //     require('@/assets/images/about/full/about_60.jpeg'),
            //     require('@/assets/images/about/full/about_61.jpeg'),
            //     require('@/assets/images/about/full/about_62.jpeg'),
            //     require('@/assets/images/about/full/about_63.jpeg'),
            //     require('@/assets/images/about/full/about_64.jpeg'),
            //     require('@/assets/images/about/full/about_65.jpeg'),
            //     require('@/assets/images/about/full/about_66.jpeg'),
            //     require('@/assets/images/about/full/about_67.jpeg'),
            //     require('@/assets/images/about/full/about_68.jpeg'),
            //     require('@/assets/images/about/full/about_69.jpeg'),
            //     require('@/assets/images/about/full/about_70.jpeg'),
            //     require('@/assets/images/about/full/about_71.jpeg'),
            //     require('@/assets/images/about/full/about_72.jpeg'),
            //     require('@/assets/images/about/full/about_73.jpeg'),
            //     require('@/assets/images/about/full/about_74.jpeg'),
            //     require('@/assets/images/about/full/about_75.jpeg'),
            //     require('@/assets/images/about/full/about_76.jpeg'),
            //     require('@/assets/images/about/full/about_77.jpeg'),
            //     require('@/assets/images/about/full/about_78.jpeg'),
            //     require('@/assets/images/about/full/about_79.jpeg'),
            //     require('@/assets/images/about/full/about_80.jpeg'),
            //     require('@/assets/images/about/full/about_81.jpeg'),
            //     require('@/assets/images/about/full/about_82.jpeg'),
            //     require('@/assets/images/about/full/about_83.jpeg'),
            //     require('@/assets/images/about/full/about_84.jpeg'),
            //     require('@/assets/images/about/full/about_85.jpeg'),
            //     require('@/assets/images/about/full/about_86.jpeg'),
            //     require('@/assets/images/about/full/about_87.jpeg'),
            //     require('@/assets/images/about/full/about_88.jpeg'),
            //     require('@/assets/images/about/full/about_89.jpeg'),
            //     require('@/assets/images/about/full/about_90.jpeg'),
            //     require('@/assets/images/about/full/about_91.jpeg'),
            //     require('@/assets/images/about/full/about_92.jpeg'),
            //     require('@/assets/images/about/full/about_93.jpeg'),
            //     require('@/assets/images/about/full/about_94.jpeg'),
            //     require('@/assets/images/about/full/about_95.jpeg'),
            //     require('@/assets/images/about/full/about_96.jpeg'),
            //     require('@/assets/images/about/full/about_97.jpeg'),
            //     require('@/assets/images/about/full/about_98.jpeg'),
            //     require('@/assets/images/about/full/about_99.jpeg'),
            //     require('@/assets/images/about/full/about_100.jpeg'),
            //     require('@/assets/images/about/full/about_101.jpeg'),
            //     require('@/assets/images/about/full/about_102.jpeg'),
            //     require('@/assets/images/about/full/about_103.jpeg'),
            //     require('@/assets/images/about/full/about_104.jpeg'),
            //     require('@/assets/images/about/full/about_105.jpeg'),
            //     require('@/assets/images/about/full/about_106.jpeg'),
            //     require('@/assets/images/about/full/about_107.jpeg'),
            //     require('@/assets/images/about/full/about_108.jpeg'),
            //     require('@/assets/images/about/full/about_109.jpeg'),
            //     require('@/assets/images/about/full/about_110.jpeg'),
            //     require('@/assets/images/about/full/about_111.jpeg'),
            //     require('@/assets/images/about/full/about_112.jpeg'),
            //     require('@/assets/images/about/full/about_113.jpeg'),
            //     require('@/assets/images/about/full/about_114.jpeg'),
            //     require('@/assets/images/about/full/about_115.jpeg'),
            //     require('@/assets/images/about/full/about_116.jpeg'),
            //     require('@/assets/images/about/full/about_117.jpeg'),
            //     require('@/assets/images/about/full/about_118.jpeg'),
            //     require('@/assets/images/about/full/about_119.jpeg'),
            //     require('@/assets/images/about/full/about_120.jpeg'),
            //     require('@/assets/images/about/full/about_121.jpeg'),
            //     require('@/assets/images/about/full/about_122.jpeg'),
            //     require('@/assets/images/about/full/about_123.jpeg'),
            //     require('@/assets/images/about/full/about_124.jpeg'),
            //      require('@/assets/images/about/full/about_125.jpeg'),
            //     require('@/assets/images/about/full/about_126.jpeg'),
            //     require('@/assets/images/about/full/about_127.jpeg'),
            //     require('@/assets/images/about/full/about_128.jpeg'),
            //     require('@/assets/images/about/full/about_129.jpeg'),
            //     require('@/assets/images/about/full/about_130.jpeg'),
            //     require('@/assets/images/about/full/about_131.jpeg'),
            // ],
            activeIndex: 0,
            activeIndexInitial: 0,
            isRollerSpeed: true,
            imagesList: [],
            escCount: 0
        }
    },
    mounted () {
        if (this.$route.query.type == 1) {
            this.imagesList = this.images
        } else if (this.$route.query.type == 2) {
            this.imagesList = this.fullImgas
        }
        document.body.style.overflow = 'auto'

        window.addEventListener('keydown', this.globalKeyDown)
    },
     beforeDestroy() {
        window.removeEventListener('keydown', this.globalKeyDown)
    },
    methods: {

        globalKeyDown(event) {
            if (event.key === 'ArrowLeft') {
                // console.log('左键被按下');
                // 处理左键逻辑
                this.prevImageSlide();
            } else if (event.key === 'ArrowRight') {
                // console.log('右键被按下');
                // 处理右键逻辑
                this.nextImageSlide();
                
            } else if (event.key === 'Escape') {
                this.escCount++; // 增加ESC键按下的次数计数
                if (this.escCount >= 2) { // 如果按了两次ESC键，则退出全屏并重置计数器
                    document.exitFullscreen()
                    window.removeEventListener('wheel', this.addMouseWheelListener)
                    this.ImagePreviewModle = false
                    this.escCount = 0; // 重置计数器
                    document.body.style.overflow = 'auto'
                } else { // 如果未达到两次，则不执行任何操作，等待下一次按键事件来增加计数器
                    setTimeout(() => this.escCount = 0, 500); // 延迟重置计数器，以防误操作（用户可能只是想关闭菜单等）
                }
                // 按下esc
                // console.log('121')
                // $Modal.remove()
                
            } else {
                this.escCount = 0
            }
        },

        handleImagePreview (index) {
            // this.ImagePreviewList = this.detailObj.imgs
            this.activeIndex = index
            this.activeIndexInitial = index
            this.ImagePreviewModle = true
            document.body.style.overflow = 'hidden'
            
            this.toggleFullScreen()
            this.addMouseWheelListener()
            
        },

        handelImagePreviewClose () {
           
            this.activeIndex = 0
            document.exitFullscreen()
            this.ImagePreviewModle = false
            window.removeEventListener('wheel', this.addMouseWheelListener)
            document.body.style.overflow = 'auto'
            
        },

         handleArrowClick (value) {
            this.activeIndex = value
        },

        handelImagesExitFullscreen () {

            if ((this.activeIndex + 1) == this.imagesList.length) {
                this.activeIndex = 0
                document.exitFullscreen()
                this.ImagePreviewModle = false
                window.removeEventListener('wheel', this.addMouseWheelListener)
                document.body.style.overflow = 'auto'
            }
            
           
        },

        addMouseWheelListener() {
            this.$nextTick(() => {
                const carouselEl = this.$refs.carousel.$el; // 获取 Carousel 元素的引用
                console.log(carouselEl)
                carouselEl.addEventListener('wheel', (event) => {
                
                    if (this.isRollerSpeed) {
                        if (event.deltaY < 0) {
                        // 向前滚动（向上）
                            this.prevImageSlide();
                        } else {
                        // 向后滚动（向下）
                            this.nextImageSlide();
                        
                        }
                    }
                    this.isRollerSpeed = false
                    setTimeout(() => {
                        this.isRollerSpeed = true
                        event.preventDefault()
                    }, 1500)
                })
            
                
            });
        },

        nextImageSlide() {
            
            // console.log(this.detailObj.imgs.length)
            if ((this.activeIndex + 1) < this.imagesList.length) {
                this.activeIndex = (this.activeIndex + 1) % this.imagesList.length
                this.$refs.carousel.next(); // 调用 Carousel 的 next 方法
                // console.log('加'+this.activeIndex)
            }
            
            
        },
        prevImageSlide() {

            if (this.activeIndex > 0) {
                this.activeIndex = (this.activeIndex - 1) % this.imagesList.length
                this.$refs.carousel.prev(); // 调用 Carousel 的 prev 方法
                // console.log('减'+this.activeIndex)
            }
            
        },

        toggleFullScreen() {
            if (!document.fullscreenElement) {
                document.documentElement.requestFullscreen().catch(err => {
                    alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`)
                })
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen()
                }
            }
        },
    }
}
</script>

<style scoped lang="scss">
.AboutDetail .about-detail-main {
    width: calc(100% - 30px);
    padding: 120px 0 0 0;
    margin: auto;
}
.AboutDetail .Image-Preview-box {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: #e8e8e8;
    z-index: 99;
}
// .about-content .about-content-model {
//     overflow-y: hidden;
//     height: 100vh; /* 让容器高度为视口高度 */
// }
.AboutDetail .Image-Preview-box {
    width: 100%;
    height: 100vh;
    overflow: hidden;
    // background: #000;
}
.AboutDetail .Image-Preview-box::v-deep .el-carousel__container {
    height: 100vh;
}
.AboutDetail .Image-Preview-box::v-deep .el-carousel__indicators {
    display: none;
}
.AboutDetail .Image-Preview-box img{
    width: 100%;
    height: 100%;
    object-fit: cover;
}
@media only screen and (min-width: 1200px) {
.el-col-lg-4-8 {
    width: 25%;
}
.el-col-lg-offset-4-8 {
    margin-left: 25%;
}
.el-col-lg-pull-4-8 {
    position: relative;
    right: 25%;
}
.el-col-lg-push-4-8 {
    position: relative;
    left: 25%;
}
}
@media only screen and (min-width: 1500px) {
.el-col-lg-4-8 {
    width: 20%;
}
.el-col-lg-offset-4-8 {
    margin-left: 20%;
}
.el-col-lg-pull-4-8 {
    position: relative;
    right: 20%;
}
.el-col-lg-push-4-8 {
    position: relative;
    left: 20%;
}
}

@media only screen and (min-width: 1920px) {
.el-col-xl-4-8 {
    width: 20%;
}
.el-col-xl-offset-4-8 {
    margin-left: 20%;
}
.el-col-xl-pull-4-8 {
    position: relative;
    right: 20%;
}
.el-col-xl-push-4-8 {
    position: relative;
    left: 20%;
}
}
</style>

